export const ensureTeamIdx = (i: number): i is 1 | 2 | 3 => {
  return [1, 2, 3].includes(i);
};
